import $ from 'jquery';

const STORAGE_KEY = 'eaplus_checkout_draft';
const BILLING_FIELDS = '.woocommerce-billing-fields :input';
const SAVE_DELAY_MS = 300;

function readDraft() {
  try {
    const draft = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
    return draft && typeof draft === 'object' && draft.values && typeof draft.values === 'object' ? draft : null;
  } catch (e) {
    return null;
  }
}

function writeDraft(draft) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
  } catch (e) {}
}

function clearDraft() {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {}
}

function singleField(form, name) {
  const field = form.elements.namedItem(name);
  return field && 'value' in field && !(field instanceof RadioNodeList) ? field : null;
}

function restore(form, config) {
  const draft = readDraft();

  if (!draft) {
    return;
  }

  if (draft.owner !== config.owner) {
    clearDraft();
    return;
  }

  config.fields.forEach((name) => {
    const field = singleField(form, name);
    const value = draft.values[name];

    if (field && field.value === '' && typeof value === 'string' && value !== '') {
      $(field).val(value).trigger('change');
    }
  });
}

function save(form, config) {
  const values = {};

  config.fields.forEach((name) => {
    const field = singleField(form, name);

    if (field && typeof field.value === 'string' && field.value.trim() !== '') {
      values[name] = field.value;
    }
  });

  writeDraft({ owner: config.owner, values });
}

function initCheckoutDraft() {
  if (typeof EAPLUS_VARS !== 'undefined' && EAPLUS_VARS.is_order_received) {
    clearDraft();
    return;
  }

  const config = window.CheckoutDraftConfig;
  const form = document.querySelector('form[name="checkout"]');

  if (!config || !Array.isArray(config.fields) || !form) {
    return;
  }

  restore(form, config);

  let timer = null;

  const flush = () => {
    if (timer === null) {
      return;
    }

    clearTimeout(timer);
    timer = null;
    save(form, config);
  };

  $(document.body).on('input change', BILLING_FIELDS, () => {
    clearTimeout(timer);
    timer = setTimeout(flush, SAVE_DELAY_MS);
  });

  window.addEventListener('pagehide', flush);
}

$(initCheckoutDraft);
